import React from 'react'
import Header from '../Components/LoginFloder/Header'
import LoginWorker from '../Components/LoginFloder/LoginWoker'

const SigninWorker = () => {
  return (
    <div>
        <Header />
        <LoginWorker />
    </div>
  )
}

export default SigninWorker